<span
  id="table-options"
  data-testid="allPositionDetails_link"
  *ngIf="!isInitiateAndReleaseFlowFromTable"
  [ngClass]="(createRequestStep$ | async) === 'input' ? 'hideSection' : 'alignRight' "
>
  <a
    (click)="exportPositionData()"
    id="download-pdf-link-multiple-lot-selections"
  ><i class="sch-download"></i>All position details</a>
</span>
<div [ngClass]="(createRequestStep$ | async) !== 'input' ? 'hideSection' : '' ">
  <div id="position-table-header">
    <span
      id="title"
      class="section-title"
    >Positions</span>
  </div>
  <div
    class="disclaimerMessage"
    data-testid="positions-lots-table_disclaimerMessage"
  >
    <p class="disclaimerMessageText">Estimated market values shown are calculated at this moment in time and are subject to market changes and availability of securities while processing.</p>
  </div>
  <div id="errorBanners">
    <mm-banners
      *ngIf="displayPositionsWarningPhase2.displayWarning && !isRestrictedAccount"
      [htmlStr]="[this.displayPositionsWarningPhase2.errorMessage]"
      [type]="'error'"
    ></mm-banners>
    <mm-banners
      *ngIf="maxLotsWarning.displayWarning"
      [htmlStr]="maxLotsWarningMessage"
      [titleText]="titleText"
      [type]="'error'"
    ></mm-banners>
  </div>
  <mm-banners
    id="setToAverageBanner"
    *ngIf="showSetToAverageMessageCounter > 0 && costBasisMethod !== 'FIFO'"
    [bannerText]="[setToAverageInformationText]"
    [type]="'information'"
    [showCloseIcon]="false"
  ></mm-banners>
  <mm-banners
    *ngIf="this.hasAnyQuantityMismatchPositions"
    [bannerText]="[positionMismatchDisclaimer]"
    [type]="'information'"
    [showCloseIcon]="false"
  ></mm-banners>
  <mm-banners
    *ngIf="this.hasDuplicateRestriction"
    [bannerText]="[duplicateRestrictionDisclaimer]"
    [type]="'information'"
    [showCloseIcon]="false"
  ></mm-banners>
  <mm-banners
    *ngIf="this.hasDuplicateRestrictionMF30DaySpecific"
    [bannerText]="[duplicateRestrictionDisclaimerMF30DaySpecific]"
    [type]="'information'"
    [showCloseIcon]="false"
  ></mm-banners>
  <div id="position-lots-table">
    <sdps-divider variation="secondary"></sdps-divider>
    <sdps-tabs
      sdps-id="position-lots-table-tabs"
      id="position-lots-table-tabs"
    ></sdps-tabs>
    <div class="totalsHeader">
      <span class="totalsTab">Totals</span>
      <span class="totalsSpanVerticalLine">Positions <span class="lineBreak"></span> <span class="textStyle">{{positions}}</span></span>
      <span class="totalsSpan">Shares <span class="lineBreak"></span><span class="textStyle">{{shares}}</span></span>
      <span class="totalsSpan">Estimated market value <span class="lineBreak"></span><span class="textStyle ">{{emvFormatted}}</span> </span>
    </div>
    <sdps-divider variation="secondary"></sdps-divider>
    <ng-template [ngIf]="!displayTable$.getValue()">
      <sdps-divider variation="secondary"></sdps-divider>
      <div class='errorMsgContainer'>
        <sdps-icon
          color="secondary"
          type="functional"
          name="warning"
          size="medium"
        ></sdps-icon>
        <div class='message'>{{tableMessage}}</div>
      </div>
    </ng-template>
    <div *ngIf="displayTable$.getValue()">
      <div class="positions-table-shell">
        <div
          class="positions-table-shell__sticky"
        >
          <div id="table-toolbar">
            <span
              id="table-info"
              class="sdps-text-body"
            >
              <mm-total-results [displayedRows]="displayedRows"></mm-total-results>
              <span id="displayed-filter-count">{{this.numberOfFilters}} filter(s) applied
                <button
                  *ngIf="this.numberOfFilters > 0"
                  class="clearAllButton"
                  (click)="clearFilters($event)"
                >Clear all</button>
                <span class="expandAll">
                  View lot details
                  <label class="switch">
                    <input
                      type="checkbox"
                      id="expandAllId"
                      (click)="expandOrCollapse()"
                    >
                    <span class="slider round"></span>
                    <span
                      class="labels"
                      data-on="ON"
                      data-off="OFF"
                    ></span>
                  </label>
                </span>
              </span>
            </span>
            <span id="table-options">
              <span
                (click)="exportPositionData()"
                class="sdps-text-body"
                id="export-download-icon"
              ><i class="sch-download"></i> Export</span>
            </span>
          </div>
        </div>

        <div class="positions-table-shell__body">
          <div
            class="positions-sticky-header"
            [class.positions-sticky-header--visible]="stickyHeaderVisible"
            [attr.aria-hidden]="!stickyHeaderVisible"
            [style.top.px]="stickyHeaderTopOffset"
          >
            <div
              class="positions-sticky-header__viewport"
              (scroll)="onStickyHeaderViewportScroll($event)"
            >
              <div
                class="positions-sticky-header__row"
                [style.width.px]="stickyHeaderTotalWidth"
              >
                <div
                  *ngFor="let column of stickyHeaderColumns; trackBy: trackStickyHeaderColumn"
                  class="positions-sticky-header__cell sdps-text-body"
                  [class.positions-sticky-header__cell--with-account-context]="!!column.accountContext"
                  [class.positions-sticky-header__cell--right]="column.alignment === 'right'"
                  [class.positions-sticky-header__cell--left]="column.alignment === 'left'"
                  [style.width.px]="column.width"
                  [style.minWidth.px]="column.width"
                  [title]="column.label"
                >
                  <span
                    *ngIf="column.accountContext"
                    class="positions-sticky-header__account-context"
                  >
                    {{ column.accountContext }}
                  </span>
                  <span class="positions-sticky-header__cell-label">
                    {{ column.label }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <ag-grid-angular
            #positionTableGrid
            class="sac-ag-grid ag-theme-material positions-master-grid"
            [detailRowAutoHeight]="true"
            [getRowHeight]="getRowHeight"
            [gridOptions]="gridOptions"
            [rowData]="(rowData$ | async)"
            [columnDefs]="columnDefs"
            [defaultColDef]="defaultColumnDefs"
            [icons]="icons"
            [headerHeight]="25"
            [floatingFiltersHeight]="25"
            [components]="frameworkComponents"
            [sortingOrder]="sortingOrder"
            [pagination]="true"
            [paginationPageSize]="10"
            [suppressPaginationPanel]="true"
            [suppressMultiSort]="true"
            (gridReady)="onGridReady($event)"
            (filterChanged)="onFilterChanged($event)"
            [suppressDragLeaveHidesColumns]="true"
            domLayout="autoHeight"
            [keepDetailRows]="true"
            (gridSizeChanged)="onGridSizeChanged()"
            (rowSelected)="onRowSelected($event)"
            [noRowsOverlayComponent]="customErrorComponent"
            [noRowsOverlayComponentParams]="customErrorComponentParams"
            [suppressNoRowsOverlay]="true"
            [floatingFilter]="true"
            (cellValueChanged)="onPositionsCellValueChanged($event)"
            [defaultExcelExportParams]="defaultExcelExportParams"
            [excelStyles]="excelStyles"
            [stopEditingWhenCellsLoseFocus]="true"
            [modules]="modules"
            [animateRows]="true"
            [masterDetail]="true"
            [alignedGrids]="[totalsTableGrid]"
            [detailCellRendererParams]="detailCellRendererParams"
            (newColumnsLoaded)="onNewColumnsLoaded($event)"
            (paginationChanged)="onPaginationChanged($event)"
            (firstDataRendered)="onFirstDataRendered($event)"
          ></ag-grid-angular>
          <ag-grid-angular
            #totalsTableGrid
            class="sac-ag-grid ag-theme-material positions-totals-grid"
            [rowData]="totalsRowdata"
            [columnDefs]="columnDefs"
            [getRowHeight]="getRowHeight"
            [gridOptions]="gridOptionsTotals"
            [icons]="icons"
            [pagination]="true"
            [paginationPageSize]="10"
            domLayout="autoHeight"
            [headerHeight]="0"
            [suppressPaginationPanel]="true"
            (gridSizeChanged)="onGridSizeChanged()"
            (gridReady)="onGridReadyTotals($event)"
            (newColumnsLoaded)="onNewColumnsLoaded($event)"
            [alignedGrids]="[positionTableGrid]"
            [modules]="globalModules"
          ></ag-grid-angular>
          <div
            id="position-table-scroll-helper"
            class="positions-bottom-scroll-helper"
            [class.positions-bottom-scroll-helper--visible]="stickyBottomScrollHelperVisible"
            [attr.aria-hidden]="!stickyBottomScrollHelperVisible"
          >
            <div
              class="positions-bottom-scroll-helper__viewport"
              (scroll)="onStickyBottomScrollHelperViewportScroll($event)"
            >
              <div
                class="positions-bottom-scroll-helper__track"
                [style.width.px]="stickyHeaderTotalWidth"
              ></div>
            </div>
          </div>
          <mm-pagination [gridApi]="gridApi"></mm-pagination>
        </div>
      </div>
      <sdps-divider variation="secondary"></sdps-divider>
    </div>
  </div>
</div>